import { storePresentation } from "@asosteam/asos-web-store-presentation-node/lib/main.es5.js";

let storeInstance: StorePresentationReturn | null = null;

export const getStorePresentationInstance = () => {
  if (!storeInstance) {
    storeInstance = storePresentation({
      environment:
        process.env.APP_ENVIRONMENT === "prod" ? "production" : "env02pt",
      warn: console.log,
    });
  }
  return storeInstance.store;
};
